import React, { useEffect, useRef, useState } from "react";
import { Chart as ChartJS, defaults } from "chart.js/auto";
import { Bar, Doughnut, Line, Chart } from "react-chartjs-2";

import "./App.css";

defaults.maintainAspectRatio = false;
defaults.responsive = true;

defaults.plugins.title.display = true;
defaults.plugins.title.align = "start";
defaults.plugins.title.font.size = 20;
defaults.plugins.title.color = "black";

export const MultiaxisLineChart = ({ Unprocessed_Data, unit }) => {
    const [datasets, set_data] = useState([]);
    const [labels, set_labels] = useState([]);
    const chartRef = useRef(null);
    const [colors, set_colors] = useState([
        '#0d6efd', '#6610f2', '#d63384', '#dc3545', '#fd7e14',
        '#ffc107', '#198754', '#20c997', '#0dcaf0', '#6f42c1',
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF", "#3337FF", "#FF5733",
        "#FFBD33", "#FF3392", "#33FF57", "#33BFFF", "#3337FF",
        "#FF5733", "#FFBD33", "#FF3392", "#33FF57", "#33BFFF",
        "#3337FF", "#FF5733", "#FFBD33", "#FF3392", "#33FF57",
        "#33BFFF", "#3337FF", "#FF5733", "#FFBD33", "#FF3392",
        "#33FF57", "#33BFFF", "#3337FF", "#FF5733", "#FFBD33",
        "#FF3392", "#33FF57", "#33BFFF"
    ]);

    function getRandomColor() {
        var letters = '0123456789abcdef';
        var color = '#';
        var colorss = [...colors];
        while (colorss.includes(color) || color == '#') {
            for (var i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
        }
        colorss.push(color);
        set_colors(colorss);
        return color;
    }

    useEffect(() => {
        // console.log(chartRef.current);
        // console.log(Unprocessed_Data);
        if (Unprocessed_Data && Unprocessed_Data != undefined) {
            const _data = Unprocessed_Data;
            var data = [];
            var label = [];
            if (_data.data == undefined) {
                return;
            }

            for (let i = 0; i < _data.data.length; i++) {
                var dataPoints = [];
                var oldVal = -1;
                for (let j = 0; j < _data.data[i].data.length; j++) {
                    const value = _data.data[i].data[j];
                    let dateString = value.date;
                    let date;
                    if (typeof dateString === 'number') {
                        date = new Date(dateString).toLocaleDateString('vi-VN'); // Convert timestamp
                    } else if (typeof dateString === "string") {
                        const dateParts = dateString.split("/");
                        if (oldVal != dateParts[dateParts.length - 1]) {
                            oldVal = dateParts[dateParts.length - 1];
                        } else
                            dateParts.pop();
                        date = dateParts.join("/");
                    } else {
                        // Fallback or handle Object Date if needed
                        date = String(dateString);
                    }

                    if (i == 0) {
                        label.push(date);
                    }
                    dataPoints.push({ x: date, y: `${Number(value.value)}` });
                }
                data.push({
                    // type: "line", showInLegend: true, name: _data.data[i].name, color: colors[i], dataPoints: dataPoints
                    label: _data.data[i].name, backgroundColor: colors[i], borderColor: i < colors.length ? colors[i] : getRandomColor(), data: dataPoints
                });
            }
            set_data(data);
            set_labels(label);
        }
    }, [Unprocessed_Data]);

    return (
        <div className="revenueCard" style={{ zIndex: '9999' }}>
            <Chart ref={chartRef}
                type="line"
                data={{
                    labels: labels,
                    datasets: datasets
                }}
                options={{
                    elements: {
                        line: {
                            // tension: 0.5,
                        },
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    aspectRatio: 2,
                    interaction: {
                        mode: datasets.length <= 20 ? "index" : "point",
                        intersect: false,
                    },
                    stacked: true,
                    plugins: {
                        title: {
                            display: true,
                            // text: 'Chart.js Line Chart - Multi Axis'
                        },
                        tooltip: {
                            enabled: datasets.length <= 20 ? true : false,
                            // position: 'nearest',
                            external: function (context) {
                                // Tooltip Element
                                if (datasets.length <= 20) return

                                let tooltipEl = document.getElementById('chartjs-tooltip');

                                // console.log(tooltipEl);
                                // Create element on first render
                                if (!tooltipEl) {
                                    tooltipEl = document.createElement('div');
                                    tooltipEl.id = 'chartjs-tooltip';
                                    tooltipEl.innerHTML = '<table></table>';
                                    document.body.appendChild(tooltipEl);
                                }

                                // Set tooltip styles
                                Object.assign(tooltipEl.style, {
                                    maxHeight: '30em',
                                    maxWidth: '50em',
                                    overflow: 'auto',
                                    // backgroundColor: "#0000001a",
                                    backgroundColor: "black",
                                    opacity: '0.78',
                                    color: 'white',
                                    position: 'absolute',
                                    // pointerEvents: 'auto',
                                    borderRadius: '5px',
                                });
                                // Add mouseleave event to tooltipEl
                                tooltipEl.addEventListener('mouseleave', () => {
                                    tooltipEl.style.opacity = 0;
                                    tooltipEl.style.display = "none";
                                });
                                // Hide if no tooltip
                                const tooltipModel = context.tooltip;
                                if (tooltipModel.opacity === 0) {
                                    // tooltipEl.style.opacity = 0;
                                    // tooltipEl.style.display = "none";
                                    return;
                                } else {
                                    tooltipEl.style.display = "block";
                                }

                                // Set caret Position
                                tooltipEl.classList.remove('above', 'below', 'no-transform');
                                if (tooltipModel.yAlign) {
                                    tooltipEl.classList.add(tooltipModel.yAlign);
                                } else {
                                    tooltipEl.classList.add('no-transform');
                                }

                                // Set Text
                                if (tooltipModel.body) {
                                    const titleLines = tooltipModel.title || [];
                                    const bodyLines = tooltipModel.body.map(bodyItem => bodyItem.lines);

                                    let innerHtml = '<thead>';

                                    titleLines.forEach(title => {
                                        innerHtml += `<tr><th>${title}</th></tr>`;
                                    });
                                    innerHtml += '</thead><tbody>';

                                    bodyLines.forEach((body, i) => {
                                        const colors = tooltipModel.labelColors[i];
                                        let style = `border-color:${colors.borderColor}; border-width: 2px`;
                                        const colorBox = `<span style="background:${colors.backgroundColor}; width:10px; height:10px; display:inline-block; margin-right:5px;"></span>`;
                                        const span = `<span style="${style}">${body}</span>`;
                                        innerHtml += `<tr><td style="width:85%;height:3px;padding-left:5px;">${colorBox}${span}</td></tr>`;
                                    });
                                    innerHtml += '</tbody>';

                                    let tableRoot = tooltipEl.querySelector('table');
                                    tableRoot.innerHTML = innerHtml;
                                }

                                const position = context.chart.canvas.getBoundingClientRect();
                                const chartHeight = context.chart.height;
                                const canvasPosition = context.chart.canvas.getBoundingClientRect();

                                // Set a fixed width for the tooltip
                                const tooltipWidth = 200; // Change this to the actual width of your tooltip
                                requestAnimationFrame(() => {
                                    tooltipEl.style.top = `${canvasPosition.top + window.pageYOffset + chartHeight / 10}px`;
                                    tooltipEl.style.left = `${position.left + window.pageXOffset + context.tooltip.caretX - tooltipWidth / 2}px`;
                                });
                                tooltipEl.style.padding = `${tooltipModel.padding}px ${tooltipModel.padding}px`;

                            }
                        },
                        legend: {
                            display: datasets.length > 20 ? false : true,
                            position: 'right',
                            labels: {
                                boxWidth: 10,
                                boxHeight: 10,
                                fontSize: 10,
                                padding: 10,
                            },
                        },
                    },
                    scales: {
                        x: {
                            // type: 'time',
                        },
                        y: {
                            beginAtZero: true,
                            title: {
                                display: true,
                                // text: unit != null ? unit : '', // Tiêu đề của trục y
                            },
                            ticks: {
                                callback: function (value, index, values) {
                                    return value.toLocaleString() + (unit != null ? ' ' + unit : '');
                                }
                            }
                        },

                    },
                    legacy: true
                }}
            />
        </div>
    );
};
